import styled from 'styled-components';
import {NavLink} from 'react-router-dom';

interface ItemProps {
  readonly active?: boolean;
}

interface NavLinkProps extends ItemProps{
  activeStyle: {
    color: string;
    backgroundColor: string;
  }
}

export const LinkContainer = styled.div`
  display: inline-block;
`;

export const ActiveLink = styled(NavLink)<NavLinkProps>`
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.2);
  background-color: var(--BackgroundColor);
  color: var(--MediumGray);
  transition: 0.3s ease;
  display: inline-block;
  text-decoration: none;
  padding: 10px 45px;
  line-height: 25px;
  overflow: hidden;
  font-size: 14px;

  &:first-of-type {
    border-radius: 10px 0 0 10px;
  }
  &:last-of-type {
    border-radius: 0px 10px 10px 0px;
  }
  &:hover {
    color: var(--DarkGray);
  }

  &.active {
    color: ${props => props.activeStyle.color};
    background-color: ${props => props.activeStyle.backgroundColor};
  }
`;

export const ActivePill = styled.div<ItemProps>`
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.2);

  transition: 0.3s ease;
  display: inline-flex;
  align-items: center;
  padding: 10px 20px;
  cursor: pointer;

  &:first-of-type {
    border-radius: 10px 0 0 10px;
  }
  &:last-of-type {
    border-radius: 0px 10px 10px 0px;
  }
  & > div:last-of-type {
    margin-bottom: 1px;
  }

  ${props => {
    return props.active
      ? `color: #FFF;
    background-color: var(--PrimaryBlue);`
      : `
    background-color: var(--BackgroundColor);
  color: var(--MediumGray);
    `;
  }};
`;

export const ActivePillText = styled.span`
  line-height: 25px;
  margin-right: 5px;
  font-size: 14px;
`;
